<template>
    <ul>
        <template v-if="cfg && cfg.list">
            <li v-for="(l, idx) in cfg.list" :key="idx"><b>{{ idx + 1 }}</b><span v-html="l"></span></li>
        </template>
    </ul>
</template>
<script>
export default {
    name: "dialog-list",
    props: {
        cfg: Object,
    }
};
</script>
<style scoped>
ul {
    list-style: none;
    padding-left: 0;
}

li {
    border-bottom: 1px solid #ccc;
    padding: 8px;
    margin: 8px 0;
}

li:hover {
    background-color: #ccc;
}

b {
    border-radius: 50%;
    background-color: #0068B7;
    color: white;
    display: inline-block;
    width: 20px;
    height: 20px;
    text-align: center;
    margin-right: 8px;
}
</style>